var map = {
	"./a/flowers.png": 15485,
	"./a/tasterkit.png": 58079,
	"./b/burring.png": 14868,
	"./c/drawing.png": 19783,
	"./d/special.png": 86526,
	"./j/tasterkit.png": 54498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18044;